import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 登录事件名称常量
export const LOGIN_EVENT_NAMES = {
  PAGE_CHANGE: 'page_change',
  SEND_CODE: 'send_code',
  PHONE_SIGNIN_BTN_CLICK: 'phone_signin_btn_click',
  EMAIL_SIGNIN_BTN_CLICK: 'email_signin_btn_click',
  EMAIL_SIGNUP_BTN_CLICK: 'email_signup_btn_click',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAIL: 'login_fail',
  EMAIL_SIGNUP_FAIL: 'email_signup_fail',

  COUNTRY_INFO: 'country_info',
  CHANGE_COUNTRY: 'change_country',

  THIRD_LOGIN_BTN_CLICK: 'third_login_btn_click',
  THIRD_LOGIN_FAIL: 'third_login_fail',
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type LoginEventNames = typeof LOGIN_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const loginBusinessLogger = createBusinessLogger<LoginEventNames>('login', categoryNames);
